export const getCustomerLoyaltyAccess = (product) => ({
  customerAccess: product?.earlyAccess?.customerAccess ?? null,
  endDate: product?.earlyAccess?.endDate ?? null,
});
